import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { CreaNonConformitaModel } from 'src/app/pages/non-conformita/model/CreaNonConformitaModel';
import { INonConformitaService } from './INonConformitaService';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { msConfig } from '../ms-config';
import { AppConstants } from 'src/environments/constants';
import { OrdiniPosizioniQuantitaModel } from 'src/app/pages/non-conformita/model/OrdiniPosizioniQuantitaModel';
import { CommonUtils } from 'src/utils/CommonUtils';
import { Utente } from 'src/app/model/utente/utente';
import { StatoNonConformita } from 'src/app/model/nonConformita/NonConformita';

@Injectable({
  providedIn: 'root',
})
export class NonConformitaService implements INonConformitaService {
  constructor(private http: HttpClient) {}

  getListNonConformitaFromOrdine(
    isTeamView: boolean,
    idOrdine: string
  ): Observable<ServiceRespone> {
    const url =
      msConfig['ms-non-conformita'] +
      AppConstants.PATH_NON_CONFORMITA_ORDRINE +
      '/' +
      idOrdine; // da implementare

    let params: any = {};
    params.isTeamView = isTeamView;
    params.first = 0;
    params.length = 100;

    return this.http.get(url, { params }).pipe(
      map((resp: ServiceRespone) => {
        let nonConformita;
        nonConformita = resp;
        return nonConformita;
      })
    );
  }

  getListNonConformitaFromPosizione(
    isTeamView: boolean,
    numeroOrdine: string,
    codicePosizione: string
  ): Observable<ServiceRespone> {
    const url =
      msConfig['ms-non-conformita'] +
      AppConstants.PATH_NON_CONFORMITA_POSIZIONE +
      '/' +
      numeroOrdine;
    let params: any = {};
    params.isTeamView = isTeamView;
    params.first = 0;
    params.length = 100;
    params.codicePosizione = codicePosizione;
    return this.http.get(url, { params }).pipe(
      map((resp: ServiceRespone) => {
        let nonConformita;
        nonConformita = resp;
        return nonConformita;
      })
    );
  }

  getListNonConformita(
    isTeamView: boolean,
    first?: number,
    length?: number,
    codiceNC?: string,
    tipologiaNC?: string,
    fornitore?: string,
    ispettore?: Utente,
    dataCreazioneInizio?: Date,
    dataCreazioneFine?: Date,
    stato?: string,
    ordinamentoPer?: string,
    direzione?: boolean
  ): Observable<ServiceRespone> {
    let url = msConfig['ms-non-conformita'] + AppConstants.PATH_NON_CONFORMITA; // da implementare
    let params: any = {};
    params.isTeamView = isTeamView;
    params.first = first;
    params.length = length;

    params = CommonUtils.containsParam(params, codiceNC, 'codiceNC');
    params = CommonUtils.containsParam(params, tipologiaNC, 'tipologiaNC');
    params = CommonUtils.containsParam(params, fornitore, 'fornitore');
    params = CommonUtils.containsParam(params, ispettore?.id, 'ispAssqual');
    params = CommonUtils.containsParam(params, stato, 'statoNC');
    params = CommonUtils.containsParam(
      params,
      ordinamentoPer,
      'ordinamentoPer'
    );
    params = CommonUtils.containsParam(params, direzione, 'direzione');

    if (dataCreazioneInizio != null) {
      params = CommonUtils.containsParam(
        params,
        CommonUtils.formatDate(dataCreazioneInizio),
        'dataCreazioneInizio'
      );
    }
    if (dataCreazioneFine != null) {
      params = CommonUtils.containsParam(
        params,
        CommonUtils.formatDate(dataCreazioneFine),
        'dataCreazioneFine'
      );
    }

    return this.http.get(url, { params }).pipe(
      map((resp: ServiceRespone) => {
        let nonConformita;
        nonConformita = resp;
        return nonConformita;
      })
    );
  }

  getTotaleNonConformita(
    isTeamView: boolean,
    codiceNC?: string,
    tipologiaNC?: string,
    fornitore?: string,
    ispettore?: Utente,
    dataCreazioneInizio?: Date,
    dataCreazioneFine?: Date,
    stato?: string
  ) {
    let url =
      msConfig['ms-non-conformita'] + AppConstants.PATH_COUNT_NONCONFORMITA; // da implementare
    let params: any = {};
    params.isTeamView = isTeamView;
    params = CommonUtils.containsParam(params, codiceNC, 'codiceNC');
    params = CommonUtils.containsParam(params, tipologiaNC, 'tipologiaNC');
    params = CommonUtils.containsParam(params, fornitore, 'fornitore');
    params = CommonUtils.containsParam(params, ispettore?.id, 'ispAssqual');
    params = CommonUtils.containsParam(params, stato, 'statoNC');

    if (dataCreazioneInizio != null) {
      params = CommonUtils.containsParam(
        params,
        CommonUtils.formatDate(dataCreazioneInizio),
        'dataCreazioneInizio'
      );
    }
    if (dataCreazioneFine != null) {
      params = CommonUtils.containsParam(
        params,
        CommonUtils.formatDate(dataCreazioneFine),
        'dataCreazioneFine'
      );
    }

    return this.http.get(url, { params }).pipe(
      map((resp: ServiceRespone) => {
        let nonConformita;
        nonConformita = resp;
        return nonConformita;
      })
    );
  }

  getDettaglioNonConformitaService(
    isTeamView: boolean,
    idNonConformita: string
  ): Observable<ServiceRespone> {
    let url =
      msConfig['ms-non-conformita'] +
      AppConstants.PATH_NON_CONFORMITA +
      '/' +
      idNonConformita;
    let params: any = {};
    params.isTeamView = isTeamView;
    return this.http.get(url, { params }).pipe(
      map((resp: ServiceRespone) => {
        let nonConformita;
        nonConformita = resp;
        return nonConformita;
      }),
      catchError(CommonUtils.errorHandler)
    );
  }

  creaNonConformita(data: CreaNonConformitaModel): Observable<ServiceRespone> {
    let params: any = {};
    let url =
      msConfig['ms-non-conformita'] + AppConstants.PATH_CREATE_NON_CONFORMITA;
    let ncInputList = null;
    let idPosizioniList = null;

    if (
      data.listOrdinePosizioneQuantita &&
      data.listOrdinePosizioneQuantita.length !== 0 &&
      data.listOrdinePosizioneQuantita[0].numeroOrdine
    ) {
      ncInputList = [];
      console.log('datalist', data.listOrdinePosizioneQuantita);
      data.listOrdinePosizioneQuantita.forEach(
        (element: OrdiniPosizioniQuantitaModel) => {
          if (element && element.posizioni) {
            idPosizioniList = [];
            element.posizioni.forEach(currCode => {
              idPosizioniList.push(currCode);
            });
          }

          let OrdPosNcInput = {
            idOrdine: element && element.idOrdine ? element.idOrdine : null,
            idPosizioniList: idPosizioniList,
            quantita:
              element && element.quantitaNonConforme
                ? element.quantitaNonConforme
                : null,
          };
          ncInputList.push(OrdPosNcInput);
        }
      );
    }

    params = CommonUtils.containsParam(params, data.tipologia, 'tipologiaNC');
    params = CommonUtils.containsParam(params, data.descrizione, 'descrizione');
    params = CommonUtils.containsParam(
      params,
      data.fornitore.id,
      'idFornitore'
    );

    return this.http.post(url, ncInputList, { params }).pipe(
      map((resp: ServiceRespone) => {
        let response;
        response = resp;
        return response;
      })
    );
  }

  cambioStato(
    idNonConformita: number,
    stato: StatoNonConformita,
    descrizione?: string,
    causa?: string,
    disposizioni?: string,
    azioniCorrettive?: string,
    noteRifiuto?: string
  ): Observable<ServiceRespone> {
    let url =
      msConfig['ms-non-conformita'] +
      AppConstants.PATH_NON_CONFORMITA +
      '/' +
      idNonConformita +
      AppConstants.PATH_NON_CONFORMITA_CAMBIO_STATO;
    let params: any = {};

    params = CommonUtils.containsParam(params, stato, 'stato');
    params = CommonUtils.containsParam(params, descrizione, 'descrizione');
    params = CommonUtils.containsParam(params, noteRifiuto, 'noteRifiuto');
    params = CommonUtils.containsParam(params, causa, 'causa');
    params = CommonUtils.containsParam(params, disposizioni, 'disposizioni');
    params = CommonUtils.containsParam(
      params,
      azioniCorrettive,
      'azioniCorrettive'
    );

    return this.http.put(url, params).pipe(
      map((resp: ServiceRespone) => {
        return resp;
      })
    );
  }

  downloadPdf(idNonConformita, isTeamView): Observable<any> {
    let url =
      msConfig['ms-non-conformita'] +
      AppConstants.PATH_NON_CONFORMITA +
      '/' +
      idNonConformita +
      '/pdf';
    let params: any = {};
    params.isTeamView = isTeamView;

    return this.http
      .get(url, { params: params, responseType: 'blob', observe: 'response' })
      .pipe(
        map(response => {
          var filename = '';
          var disposition = response.headers.get('content-disposition');
          console.log(response);

          if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          return {
            filename: filename,
            data: response,
          };
        })
      );
  }
}
